import { RegularIconNames, Message, useDesignLanguagePerClass, useIsDesignLanguage, DesignLanguage } from '@afterpaytouch/core'
import { Cohort } from '@afterpaytouch/portal-api'
import { useFlag } from '@afterpaytouch/feature'
import React, { FunctionComponent } from 'react'
import { useCheckoutState, useCohort, useHasBillingAgreements, useIsBillingAgreementApprovalProcess } from '../../state'

import styles from './style.module.css'
import { useTranslation } from '../../utils/convergence'
import { Features } from '../../model/features'

export const BillingAgreementMessage: FunctionComponent = () => {
  const { t } = useTranslation()
  const { checkout } = useCheckoutState()
  const hasBillingAgreements = useHasBillingAgreements()
  const isBillingAgreementApprovalProcess = useIsBillingAgreementApprovalProcess()
  const designLanguageClass = useDesignLanguagePerClass(styles)
  const isArcadeDesignLanguage = useIsDesignLanguage(DesignLanguage.Arcade)
  const cohort = useCohort()
  const iconName: RegularIconNames = isArcadeDesignLanguage ? 'CheckFill' : 'Info'
  const isCashOnlyCohort = cohort === Cohort.CashOnly
  const enableBillingAgreementForCashCohort = useFlag(Features.ENABLE_BA_CASH_COHORT, false)

  if (isCashOnlyCohort && !enableBillingAgreementForCashCohort) {
    return null
  }

  return (
    <>
      {(hasBillingAgreements || isBillingAgreementApprovalProcess) && (
        <div className={designLanguageClass.wrapper}>
          <Message
            iconName={iconName}
            kind='Basic'
            description={t('summary:recurringPaymentMessage.description', {
              merchantName: checkout?.merchant?.name,
            })}
            testNameSpace='recurring-payment'
          />
        </div>
      )}
    </>
  )
}
